"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  backdrop-filter: blur(4px);\n  background: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Blur = void 0;

var web_1 = require("@thesisedu/web");

var polished_1 = require("polished");

var react_1 = __importDefault(require("react"));

var theme_1 = require("../theme");

function Blur(_ref) {
  var forceDark = _ref.forceDark;

  var _ref2 = react_1.default.useContext(web_1.ThemeContext) || {},
      dark = _ref2.dark;

  var theme = (0, theme_1.useTheme)();
  return react_1.default.createElement(Container, {
    background: forceDark ? (dark || theme)['@gray-1'] : theme['@gray-1']
  });
}

exports.Blur = Blur;
var Container = web_1.styled.div(_templateObject(), function (props) {
  return (0, polished_1.transparentize)(0.5, props.background);
});